import React from "react"
import classnames from "classnames"
import {
  ButtonIcon,
  CrossIcon
} from 'AtomicComponents'
import styles from "./Tooltip.less"

class Tooltip extends React.PureComponent {
  constructor(props){
    super(props)
    this.state = {
      show: false,
    }
  }

  componentDidMount(){
    this.setState({
      show: true,
    })
  }

  _handleClose = (event) => {
    this.setState({
      show:false
    })
  }

  render() {

    const {
      children,
      position = 'bottomRight',
      closeIcon = true,
      size = 'medium'
    } = this.props
    const { show } = this.state

    if (!show) return (<div></div>)

    return (
      <div
        className={classnames({
          [styles.Tooltip]: true,
          [styles.TooltipSmall]: size === 'small',
          [styles.TooltipMedium]: size === 'medium',
          [styles.TooltipLarge]: size === 'large',
          [styles.TooltipBottomRight]: position === 'bottomRight',
          [styles.TooltipBottomLeft]: position === 'bottomLeft',
          [styles.TooltipTopRight]: position === 'topRight',
          [styles.TooltipTopLeft]: position === 'topLeft',
          [styles.TooltipTopCenter]: position === 'topCenter',
          [styles.TooltipBottomCenter]: position === 'bottomCenter',
          [styles.TooltipWithCloseIcon]: closeIcon
        })}>
        {closeIcon &&
          <div className={classnames({
            [styles.TooltipIcon]: true,
          })}>
            <ButtonIcon
              onClick={this._handleClose}
            >
              <CrossIcon style={{
                width: "10px",
                height: "10px"
              }} />
            </ButtonIcon>
          </div>
        }
        <div className={classnames({
          [styles.TooltipTriangle]: true,
        })}></div>
        <div className={classnames({
          [styles.Children]: true,
        })}>{children}</div>

      </div>
    )
  }
}


export default Tooltip



// WEBPACK FOOTER //
// ./src/AtomicContainers/Tooltip/Tooltip.jsx